import { ref } from "vue";
import {
    Resource,
    ResourceState,
    resourceStatePrototype,
    useResourceState,
} from "@/domains/app/resource";

export type Game = Resource & {
    label: string;
    injuries_map: string;
    order_num: number | null;
    links: { injuries_map: string };
};

export type GameState = ResourceState<Game>;

/**
 * Create a game state to get data and its mutators
 * @param id Id of the game that the state should be related to
 * @returns a game state with the data and mutators
 */
export function useGame(id?: number): GameState {
    const state: GameState = {
        data: ref(null),
        apiRoute: "games",
        apiErrors: ref(null),
        save: () => resourceStatePrototype.save(state),
        del: () => resourceStatePrototype.del(state),
        init: () =>
            resourceStatePrototype.init(id, state, {
                id: -1,
                label: "",
                injuries_map: "",
                order_num: null,
                links: { injuries_map: "" },
            }),
    };

    return useResourceState(state);
}
